import"../../chunk-SDBWQ4EE.js";const n=(t,r=2)=>(t=t||0,String(t).padStart(r,"0"));export{n as padStart};
